import { render, staticRenderFns } from "./CorposSociais.vue?vue&type=template&id=40631f0c&"
import script from "./CorposSociais.vue?vue&type=script&lang=js&"
export * from "./CorposSociais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports